import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

function Footer() {
    return (
        <div className='footer-container font-tiskani-mali'>

            <div className="margin-padding footer-background-colour footer-column">
                <div className="padding-footer footer-background-colour">
                    <small className='website-rights'>Beauty Boutique d.o.o. za trgovinu i usluge</small>
                </div>
                <div className="padding-footer footer-background-colour">
                    <small className='website-rights'>IBAN: HR2923400091111309404, Privredna banka Zagreb d.d.</small>
                </div>
                <div className="padding-footer footer-background-colour">
                    <small className='website-rights'>OIB: 02535697732</small>
                </div>
            </div>

            <div className="margin-padding footer-background-colour footer-column">
                <div className="container-center footer-background-colour">
                    {/*<p className='font-size-contact font-italic' style={{ fontSize: "medium" }}>Kontakt</p>*/}
                </div>
                <div className="padding-footer footer-background-colour">
                    <small className='website-rights'>Berislavićeva 15, 10000 Zagreb, Hrvatska</small>
                </div>
                <div className="padding-footer footer-background-colour">
                    <small className='website-rights'>Email adresa: info@beautyboutique.hr</small>
                </div>
                <div className="padding-footer footer-background-colour">
                    <small className='website-rights'>Broj mobitela: 091 7662 599</small>
                </div>
            </div>

            {/* Third column: Social */}
            <div className="margin-padding footer-background-colour footer-column">
                <div className="container-center footer-background-colour">
                    <p className='font-size-contact font-italic' style={{ fontSize: "medium" }}>Pratite nas</p>
                </div>

                <div className="padding-footer footer-background-colour" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <a
                        href="https://www.instagram.com/beautyboutique.hr"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-black hover:text-pink-500 flex items-center gap-2"
                        style={{ textDecoration: "none" }}
                    >
                        <FontAwesomeIcon icon={faInstagram} size="3x" />
                        {/* Uncomment below if you want the text next to icon */}
                        {/* <span style={{ fontSize: "small" }}>Instagram</span> */}
                    </a>
                </div>


                {/*<div className="padding-footer footer-background-colour">*/}
                {/*    <a*/}
                {/*        href="https://www.instagram.com/youraccount"*/}
                {/*        target="_blank"*/}
                {/*        rel="noopener noreferrer"*/}
                {/*        className="text-black hover:text-pink-500 flex items-center gap-2"*/}
                {/*        style={{ textDecoration: "none" }}*/}
                {/*    >*/}
                {/*        <FontAwesomeIcon icon={faInstagram} size="3x" />*/}
                {/*        /!*<span>Instagram</span>*!/*/}
                {/*    </a>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default Footer;
